import { render } from "./Projects.vue?vue&type=template&id=c1ee42b8&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=c1ee42b8&scoped=true&lang=css"
import "./Projects.vue?vue&type=style&index=1&id=c1ee42b8&lang=css"

import exportComponent from "/opt/build/repo/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ee42b8"]])

export default __exports__